import script from "./xt_navbar.vue?vue&type=script&setup=true&lang=js"
export * from "./xt_navbar.vue?vue&type=script&setup=true&lang=js"

import "./xt_navbar.vue?vue&type=style&index=0&id=0c60a0d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c60a0d9"]])

export default __exports__